
import { trackContactEmailClick } from '~/lib/linkedInTracker'

export default {
  data() {
    return {
      isShowingForm: false,
    }
  },
  methods: {
    trackContactEmailClick,
    toggleForm() {
      this.isShowingForm = !this.isShowingForm
    },
  },
}
